module.exports = __webpack_public_path__ + "img/elevator-worry.40a2c811.png";